import React from "react";
import { Box } from "@mui/material";
import TextField from "@mui/material/TextField";
import Fade from "react-reveal/Fade";
import Alert from "@mui/material/Alert";
import { useForm } from "react-hook-form";
import { useStateContext } from "../../../../context/StateContext_KO";
import { useAuth } from "../../../../context/AuthContext";
import { useTranslation } from "react-i18next";

const EnterEmail = (props) => {
  const { currentUser } = useAuth();
  const { t, i18n } = useTranslation();
  const { setEmailInBasket, emailInBasket } = useStateContext();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { email: currentUser ? currentUser.email : "" },
  });

  const submit = (data) => {
    console.log(data.email);
    props.setEmail(data.email);
    setEmailInBasket(data.email);
    window.sessionStorage.setItem("emailInBasket", data.email);
    console.log("data >>>", data);

    props.setGuestPassword(data.guest_password);
    props.setPhone(data.phone);

    props.goToNextStep();
  };

  return (
    <Box sx={{ pt: 7, px: 7 }}>
      <Fade delay={300}>
        <form
          onSubmit={handleSubmit((data) => {
            submit(data);
          })}
        >
          <Box sx={{ pb: 2, lineHeight: "190%" }}>
            <div
              dangerouslySetInnerHTML={{ __html: t("Your Email Address") }}
            ></div>
          </Box>

          {currentUser ? (
            <TextField
              id="outlined-basic"
              label={t("email")}
              variant="filled"
              value={currentUser ? currentUser.email : ""}
              sx={{ width: 1 }}
              {...register("email", {
                required: t("Email is required."),
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Please put valid email address.",
                },
              })}
            />
          ) : (
            <TextField
              id="outlined-basic"
              label={t("email")}
              variant="filled"
              sx={{ width: 1 }}
              {...register("email", {
                required: t("Email is required."),
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "Please put valid email address.",
                },
              })}
            />
          )}

          <TextField
            id="outlined-basic"
            label={t("Phone")}
            variant="filled"
            sx={{ width: 1, mt: 2 }}
            {...register("phone", {
              required: t("Phone number is required."),
              minLength: {
                value: 5,
                message: t("Phone number's length is too short."),
              },
            })}
          />

          {!currentUser && (
            <TextField
              label={t("Guest Checkout Password")}
              variant="filled"
              sx={{ mt: 1, width: 1 }}
              {...register("guest_password", {
                required: t("Password is required for guest checkout."),

                pattern: {
                  message: "Please put a password for guest checkout.",
                },
              })}
            />
          )}
          <button
            type="submit"
            className="custom_btn"
            style={{ marginTop: "20px", marginBottom: "40px" }}
          >
            {t("Continue")}
          </button>
          {errors.email && (
            <Alert sx={{ my: 3 }} severity="warning">
              {errors.email?.message}
            </Alert>
          )}
          {errors.phone && (
            <Alert sx={{ my: 3 }} severity="warning">
              {errors.phone?.message}
            </Alert>
          )}
          {errors.guest_password && (
            <Alert sx={{ my: 3 }} severity="warning">
              {errors.guest_password?.message}
            </Alert>
          )}
        </form>
      </Fade>
    </Box>
  );
};

export default EnterEmail;
